import { z } from 'zod'

/**
 * block-structure.json — sidecar opzionale nel bundle .arianna.
 *
 * Shape: { "<subParaId>": ["<blockId>", ...] }
 *
 * Per ogni sotto-paragrafo, lista ordinata dei blockId top-level
 * prodotti dalla tokenizzazione canonica markdown-it (extractTopLevelBlocks /
 * extractTopLevelBlocksRaw da @arianna/reader-core).
 *
 * I blockId hanno forma `${subParaId}/b${counter}` con counter da 1,
 * scoped per sotto-paragrafo (riparte da b1 per ogni subParaId).
 *
 * Retrocompatibilità: il file è OPZIONALE in lettura. I bundle privi di
 * block-structure.json restano validi; i consumer (server, reader) devono
 * gestire l'assenza senza errori.
 */
export const BlockStructureSchema = z.record(z.string().min(1), z.array(z.string().min(1)))
export type BlockStructure = z.infer<typeof BlockStructureSchema>
